import { Property } from "./interfaces";

export const vrUnitOS: Property = {
    title: "Valor Unitario de OS",
    type: "integer"
}